import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-no-content',
  templateUrl: './no-content.component.html',
  styleUrls: ['./no-content.component.sass'],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class NoContentComponent {}
